import {FC, useEffect, useState} from 'react';
import {  emptyTokenLogo, mellIcon, moneyGreen } from '../../../assets';
import styles from './Earn.module.scss';
import {ContractAddress, Reward} from '../../api/contract';
import {useTranslation} from "react-i18next";
import {GetMainRewardService} from "../../../entities/deposit/api/get-mainreward-service.ts";
import {contractABI} from "../../api/contract/config.ts";
import {ConnectorType, useAppKitProvider} from "@reown/appkit/react";
import {FlipNumber} from "../flip-value/flip-value.ui.tsx";



const Earn: FC<{ reward: number; additionalsReawds: Reward[], index: bigint | null, address: ContractAddress }> = ({ reward, additionalsReawds, index, address }) => {
    const {t} = useTranslation()
    const {walletProvider} = useAppKitProvider<ConnectorType>('eip155');
    const [mainReward, setMainReward] = useState(reward);

    const mainRewardService = new GetMainRewardService(import.meta.env.VITE_CONTARCT_ADDRESS, contractABI, walletProvider, address)


    useEffect(() => {
        console.log('render')
        if (!index) return;
        const intervalId = setInterval(async () => {
            setMainReward(Number(await mainRewardService.getMainReward(index)))
        }, 10_000)

        return () => {
            clearInterval(intervalId)
        }
    }, []);

    return (
        <div className={styles.earn}>
            <div className={styles.main}>
                <div className={styles.title}>
                    <img
                        src={moneyGreen}
                        alt=""
                    />
                    <p>{t('earn_deposit')} MOON</p>
                </div>

                <div className={styles.value}>
                    <img
                        src={mellIcon}
                        alt=""
                    />
                    {/*<span>{Math.ceil(mainReward).toLocaleString()}</span>*/}
                    <FlipNumber value={Math.ceil(mainReward).toLocaleString()}/>
                </div>
            </div>

            {additionalsReawds && additionalsReawds.length > 0 && (
                <div className={styles.additionals + ' start'}>
                    {additionalsReawds.map((reward) => (
                        <div
                            className={styles.item}
                            key={Number(reward.amount)}>
                            <div className={styles.title}>
                                <div className={styles.circle}></div>
                                <p>{t('earn_deposit')} {reward.symbol}</p>
                            </div>

                            <div className={styles.value}>
                                <img
                                    src={emptyTokenLogo}
                                    alt=""
                                />
                                <span>{Math.ceil(Number(reward.amount) / 1000000000000000000).toLocaleString()}</span>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Earn;
